import createRoute     from '@widesk-ui/tools/createRoute';
import ProfessionModel from '@models/website/ProfessionModel';

const route = createRoute.splitView(
	'/configuration/professions',
	'website',
	'ProfessionSplitView',
	ProfessionModel.localize('plural'),
);
export default route;
